// extracted by mini-css-extract-plugin
export default {"container":"RecipeStep_container__C-2KZ","step":"RecipeStep_step__kfMHG","text":"RecipeStep_text__zxE-e"};